/**
 * Whether two values of plain data (what JSON and IndexedDB hold: scalars,
 * arrays, objects) are the same by structure. Arrays compare in order; an
 * object's keys in any order, and a key present on one side only differs.
 */
export function sameData(a: unknown, b: unknown): boolean {
  if (Object.is(a, b)) return true;
  if (typeof a !== 'object' || typeof b !== 'object' || a === null || b === null) return false;
  const arrays = Array.isArray(a);
  if (arrays !== Array.isArray(b)) return false;
  if (arrays) {
    const x = a as unknown[];
    const y = b as unknown[];
    return x.length === y.length && x.every((v, i) => sameData(v, y[i]));
  }
  const x = a as Record<string, unknown>;
  const y = b as Record<string, unknown>;
  const keys = Object.keys(x);
  return keys.length === Object.keys(y).length && keys.every((k) => Object.hasOwn(y, k) && sameData(x[k], y[k]));
}
